// This file is AUTOGENERATED, do not edit it manually!!!

export const projectFinancials = {
    actual_billing: 'Facturable Real',
    actual_cost: 'Coste Real',
    ActualBillableExpenses: 'Gastos Facturables Reales',
    ActualBillableExpensesShort: 'Gastos Facturables Reales',
    ActualBilledShort: 'Facturación Real',
    ActualBillingShort: 'Facturable Real',
    ActualBudgetProfitability: 'Rentabilidad Presupuestaria Real',
    ActualCost: 'Coste Real',
    ActualCostQtip: 'Costo Real = Costo de Mano de Obra Real + Gastos Reales',
    ActualExpenses: 'Gastos Reales',
    ActualExpensesListTitle: 'Real',
    ActualExpensesShort: 'Gastos Reales',
    ActualHours: 'Horas Reales',
    ActualLaborBilling: 'Mano de Obra Facturable Real',
    ActualLaborBillingShort: 'Mano de Obra Facturable Real',
    ActualLaborCost: 'Costo de Mano de Obra Real',
    ActualLaborCostShort: 'Costo de Mano de Obra Real',
    add_activities_flat_fees: 'añadir tarifas planas de actividades',
    add_as_actual_expense: 'Agregar como gasto real',
    add_planned_billable_expenses: 'agregue gastos facturables planificados',
    add_received_payment: 'Agregar pago recibido',
    add_scheduled_payment: 'Añadir pago programado',
    AddActivitiesBudgets: 'añadir presupuestos de actividades',
    AddBudgetLabel: 'Añadir Presupuesto para este Proyecto',
    AddPlannedExpenses: 'añadir gastos planificados',
    Amount: 'Cantidad',
    ApproveTooltip: 'Transfiere los gastos planificados a los reales',
    back_to_metrics: 'Volver a métricas',
    batch_actual_text: 'Agregar como Gasto Real',
    batch_billed_text: 'Marcar como Facturado',
    batch_operation_failed_description: 'La operación no se pudo completar por este motivo. Esto puede deberse a que se ha eliminado o a que no tiene permisos para realizar operaciones con él. Consulte con su {brandName} administrador para conocer las posibles causas.',
    batch_operations_failed_description: 'La operación no se pudo completar por {0} gastos {1} no realizados. Esto puede deberse a que se han eliminado o a que carecen de permisos para realizar operaciones con ellos. Consulte con su {brandName} administrador para conocer las posibles causas.',
    Billable: 'Facturable',
    Billed: 'Facturado',
    BilledPercentQtip: 'Facturado = (Mano de Obra Facturada + Gastos Facturados) / EAC Facturable * 100%',
    BilledVsActualCost: 'Facturado vs Costo Real',
    Billing: 'Facturable',
    BillingHelp: 'En la sección Facturación, puede elegir el tipo de facturación adecuado para su proyecto y establecer una tarifa, como por hora, o una cantidad fija para un proyecto de tarifa plana.',
    BillingSettings: 'Configuración de Facturación',
    BillingSettingsTitle: 'Facturación',
    BillingType: 'Tipo de facturación',
    BillingTypeLabel: 'Calculado por ',
    BillingUtilization: 'Utilización de Facturación Por Adelantado',
    BudgetedCost: 'Presupuesto Total del Proyecto',
    BudgetHelp: 'En esta sección puede ver el presupuesto total del proyecto compuesto por el de todas sus actividades y establecer un presupuesto a nivel de proyecto.',
    CancelTooltip: 'Cancelar',
    chart_actual_billing: 'Facturable Real',
    chart_actual_cost: 'Coste Real',
    chart_billable_expenses: 'Gastos Facturables',
    chart_billed: 'Facturado',
    chart_billed_expenses: 'Gastos Facturados',
    chart_eac_billing: 'EAC Facturable',
    chart_expenses: 'Gastos',
    chart_non_billable_expenses: 'Gastos no facturables',
    chart_payments: 'Pagos Recibidos',
    chart_scheduled_payments: 'Pagos Programados',
    ContingencyPadding: 'Contingencia',
    Cost: 'Coste Total',
    CPI: 'IPC',
    CurrencyLabel: 'Divisa',
    CustomerHourlyRateLabel: 'Precio por hora para el cliente',
    Date: 'Fecha',
    DeletePaymentConfirmation: 'Está seguro de que desea eliminar este registro?',
    DeleteTooltip: 'Eliminar',
    Description: 'Descripción',
    DetailedReportTitleTemplate: 'Informe Detallado para {0}',
    EAC: 'Estimación al Finalizar',
    eac_billing: 'Estimación al Finalizar (EAC) Facturable',
    eac_cost: 'Costo Estimado al Finalizar (EAC)',
    EACBilling: 'EAC Facturable',
    EACBillingLong: 'Estimación al Finalizar (EAC) Facturable',
    EACBillingQtip: 'Estimación al Finalizar (EAC) Facturable = Facturable Real + ETC Facturable',
    EACBillingQtipInfo: 'Monto total estimado facturable, incluidos la mano de obra facturable y los gastos facturables (Real + Estimado hasta la Finalización (ETC.))',
    EACCost: 'Costo Estimado al Finalizar (EAC)',
    EACCost_short: 'Coste del EAC',
    EACCostQtip: 'Costo Estimado al Finalizar (EAC) = Costo Real + Costo ETC',
    EnteredBy: 'Ingresado Por',
    EstimatedBudgetProfitability: 'Rentabilidad Presupuestaria Estimada',
    EstimatedCostVariance: 'Variación del Costo Estimado',
    EstimatedExpenses: 'Gastos Estimados',
    EstimatedHours: 'Horas Estimadas',
    EstimatedProfit: 'Beneficio Esperado',
    EstimatedProfitPercentQtip: 'Beneficio Esperado ( % ) = (EAC Facturable-Costo de EAC) / EAC Facturable * 100%',
    EstimatedProfitQtip: 'Beneficio Esperado = EAC Facturable-Costo de EAC',
    etc_billing: 'Estimación hasta la finalización (ETC) Facturable',
    etc_cost: 'Costo Estimado hasta la finalización (ETC)',
    ETCBillableExpenses: 'ETC Gastos Facturables',
    ETCBillableExpensesShort: 'ETC Gastos Facturables',
    ETCBilling: 'ETC Facturable',
    ETCBillingShort: 'ETC Facturable',
    ETCCost: 'Coste del ETC',
    ETCCostShort: 'Coste del ETC',
    ETCCosttQtip: 'Costo Estimado hasta la Finalización (ETC) = Costo de Mano de obra de ETC + Gastos de ETC',
    ETCExpenses: 'Gastos de ETC',
    ETCExpensesShort: 'Gastos de ETC',
    ETCLaborBilling: 'ETC Mano de Obra Facturable',
    ETCLaborBillingShort: 'ETC Mano de Obra Facturable',
    ETCLaborCost: 'Coste Laboral del ETC',
    ETCLaborCostShort: 'Coste Laboral del ETC',
    ExpectedRevenue: 'Ingresos Previstos',
    expenses: '1#{0} gasto#{0} gastos',
    expenses_updated_successfully_plural: '1#Gastos se ha actualizado correctamente.#{0} los gastos se han actualizado correctamente.',
    FeeAmount: 'Importe de la tasa',
    FlatFee: 'Tarifa plana',
    GeneralInfo: 'Información General',
    HourlyRate: 'Precio por hora',
    InternalBudget: 'Presupuesto',
    InternalEstimatedCost: 'Coste Estimado',
    LaborBilling: 'Mano de Obra Facturable',
    LaborCost: 'Coste Laboral',
    legend_actual: 'Real',
    legend_estimated_at_completion: 'Estimación al Finalizar',
    log_actual_expense: 'Registrar el gasto real',
    log_expenses: 'Registro de Gastos',
    log_payments: 'Registro de Pagos',
    log_planned_expense: 'Registro los gastos planificados',
    no_targets: 'No hay objetivos que mostrar',
    NoActualExpenses: 'No hay gastos.',
    None: 'Nada',
    NoneCurrency: 'Elija la moneda',
    NoPayments: 'No hay pagos.',
    NoPlannedExpenses: 'No hay gastos planificados.',
    NotBillable: 'No facturable',
    NotBillableLabel: 'No facturable',
    NotBilled: 'No facturado',
    OpenRateCard: 'Tarjeta de tarifa abierta',
    OutstandingPaymentBalance: 'Saldo De Pago Pendiente',
    PaymentDescriptionWatermark: 'Descripción...',
    PaymentReceived: 'Pago Recibido',
    payments_total: '1#{0} pago#{0} pagos',
    PaymentsOfSchedPayments: 'Pagos de Programados. Pagos',
    PercentageBilled: 'Porcentaje Facturado',
    PercentageProjectBilled: 'Porcentaje Facturado',
    Percentages: 'Porcentaje',
    PlannedExpenses: 'Gastos Planificados',
    PlannedExpensesListTitle: 'Planificado',
    ppFormat: '{0} pp',
    Profit: 'Beneficio',
    ProfitQtip: 'Beneficio = Facturable Real-Coste Real',
    ProjectActivityName: 'Proyecto / Nombre de la actividad',
    ProjectBilling: 'Facturación de proyecto',
    ProjectBillingIsBasedOn: 'La facturación del proyecto se basa en',
    ProjectBillingUtilization: 'Utilización de Facturación',
    ProjectBudget: 'Presupuesto Laboral',
    ProjectCost: 'Costo Interno del Proyecto',
    ProjectCostVariance: 'Variación del Costo del Proyecto',
    ProjectEarnedValue: 'Valor Ganado del Proyecto',
    ProjectEarnedValueInfo: 'Representa la salud del proyecto',
    ProjectExpectedRevenue: 'Ingresos Previstos del Proyecto',
    ProjectFixedCostLabel: 'Tarifa plana del proyecto',
    ProjectHourlyRateLabel: 'Precio por hora del proyecto',
    ProjectPayments: 'Pagos de Proyectos',
    ProjectPlannedExpenses: 'Gastos Planificados del Proyecto',
    ProjectPlannedExpensesInfo: 'Gastos planificados para un proyecto específico y gastos planificados agregados de sus actividades',
    ProjectProfit: 'Beneficio del Proyecto',
    ProjectProfitability: 'Rentabilidad del Proyecto',
    ProjectProfitabilityInfo: 'Representa el porcentaje de valor creado por proyecto',
    ProjectTimeUsage: 'Uso de Tiempo del Proyecto',
    ProjectTimeUsageInfo: 'Muestra la cantidad de tiempo presupuestado que hemos utilizado, real como porcentaje de las horas estimadas',
    ProjectWorkInProgress: 'Proyecto En Curso',
    PymentsVsActualCost: 'Pagos vs Costo Real',
    RateCardLabel: 'Tarjeta de tarifa',
    Receipt: 'Recibo',
    Received: 'Recibido',
    ReceivedPaymentsListTitle: 'Recibido',
    RemainingInternalBudget: 'Presupuesto Restante',
    RemainingInternalBudgetQtip: 'Presupuesto Restante = Presupuesto - Costo Real',
    RemainingInternalBudgetQtipForProject: 'Presupuesto Restante = Presupuesto Total - Costo Real',
    ResourceHourlyRateLabel: 'Precio por hora del recurso',
    Revenue: 'Ingreso',
    Scheduled: 'Programado',
    ScheduledPaymentsListTitle: 'Programado',
    set_targets: 'Establecer objetivos utilizando el',
    Settings: 'Configuración',
    ShowAll: 'MOSTRAR TODO',
    ShowBreakdown: 'Mostrar desglose',
    ShowFull: 'MOSTRAR COMPLETO',
    SPI: 'SPI',
    tab_Actual: 'Gastos Reales',
    tab_expenses: 'Gastos',
    tab_overview: 'Visión general',
    tab_payments: 'Pagos',
    tab_Planned: 'Gastos Planificados',
    tab_Received: 'Pagos Recibidos',
    tab_Scheduled: 'Pagos Programados',
    tab_targets: 'Objetivos',
    TargetBudget: 'Presupuesto Total',
    TargetLaborRevenue: 'Ingresos Laborales Objetivos',
    TargetProfit: 'Beneficio Objetivo',
    TargetRevenue: 'Ingresos Objetivo',
    Targets: 'Objetivos',
    targets_tab: 'Pestaña Objetivos',
    TargetsEACBilling: 'EAC Facturable',
    TaskRateLabel: 'Tasa de actividad',
    TimeAndMaterial: 'Tiempo & Material',
    TimeUsage: 'Uso del Tiempo',
    TitleText: 'Financiero',
    total_billable: 'Total Facturable',
    TotalBilled: 'Total Facturado',
    TotalProjectBudget: 'Presupuesto Total del Proyecto',
    TotalProjectPayments: 'Pagos Totales del Proyecto',
    TotalProjectPaymentsInfo: 'Resumen de todos los pagos realizados por todos los clientes',
    TotalTargetRevenue: 'Destino Total Ingresos',
    TrackProfitAs: 'Seguimiento de ganancias como',
    Validation_DateMandatory: 'La fecha es un campo obligatorio.',
    Validation_InvalidAmount: 'La cantidad debe ser un número positivo.',
    Validation_InvalidDate: 'La fecha debe estar en \'{0}\' formato.',
    Validation_Range: 'El valor no se encuentra dentro del rango esperado.',
    Variance: 'Varianza',
    warning_currency: 'La moneda se toma de la tarjeta de tarifa elegida',
    WorkInProgress: 'Trabajo En Progreso',
};
